import type { IntercomBootParams } from 'utils/intercom'

interface BuildIntercomParamsInput {
  userId: string
  firstName?: string
  lastName?: string
  email: string
  phone: string | null
  createdAt: number | null | undefined
  companyId: string | undefined
  companyName: string | undefined
  companyWebsite: string | null | undefined
  companyPortalUrl: string | undefined
  intercomUserJwt: string | null
}

export const buildIntercomParams = ({
  userId,
  firstName = '',
  lastName = '',
  email,
  phone,
  createdAt,
  companyId,
  companyName,
  companyWebsite,
  companyPortalUrl,
  intercomUserJwt,
}: BuildIntercomParamsInput): IntercomBootParams => {
  const name = `${firstName} ${lastName}`.trim()
  const company =
    companyId && companyName
      ? { id: companyId, company_id: companyId, name: companyName, website: companyWebsite, customer_portal_website: companyPortalUrl }
      : undefined

  return {
    user_id: userId,
    ...(name && { name }),
    email,
    phone,
    created_at: createdAt,
    ...(company && { company }),
    ...(intercomUserJwt && { intercom_user_jwt: intercomUserJwt }),
  }
}
